import { loginApi } from "../../services/auth/authService";
import { saveTokens } from "../../utils/tokenManager";
import type { LoginResponse } from "../../models/auth/AuthModels";

export const loginUser = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const result = await loginApi(email, password);

    if (!result.token || !result.refreshToken) {
      throw new Error("Invalid token response");
    }

    saveTokens(result.token, result.refreshToken);

    return result;
  } catch (err: any) {
    throw new Error(err.message || "Login failed");
  }
};